"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboOfferPersonal = isComboOfferPersonal;
exports.isComboPersonal = isComboPersonal;
function isComboOfferPersonal(offer) {
    return offer.limitedToDriverIds?.length === 1;
}
function isComboPersonal(comboType) {
    return ["Personal", "PersonalMultiday"].includes(comboType ?? "");
}
//# sourceMappingURL=isComboOfferPersonal.js.map